// libs
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// app
import { AppModule } from './app/app.module';
import { ChatProviders, ENVIRONMENT, EXTERNAL_API, GATE_CONSTANTS, STORAGE_KEYS } from "./app/_constants/app.constants";
import { Config, CONFIG } from './app/_models/config';

let endpointHostname = '';
// let externalApi: any = {};
if (window.location.hostname === 'travelhelp.united.com') {
  endpointHostname = 'https://travelhelp.united.com/api/';
  // externalApi = EXTERNAL_API.PROD;
}else if (window.location.hostname === 'travelhelp-stage.united.com') {
  endpointHostname = 'https://travelhelp-stage.united.com/api/';
  // externalApi = EXTERNAL_API.STAGE;
}
else {
  endpointHostname = 'https://travelhelp-qa.united.com/api/';
  // externalApi = EXTERNAL_API.QA
}

void fetch(`${endpointHostname}config`, { method: 'POST'})
  .then((response) => response.json())
  .catch(e => e)
  .then((data) => {

    const config = data.data;

    if (ENVIRONMENT.PROPERTIES.production) {
      enableProdMode();
    }

    if (sessionStorage.getItem(STORAGE_KEYS.PARAMS.toString())) {
      let params = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PARAMS.toString()))
      if (params.a?.toUpperCase() === config.DEPARTMENTS.VIP.NAME && params.g?.toUpperCase() === GATE_CONSTANTS.VIP) {
        config.CHAT_PROVIDER = ChatProviders.WEBEX
      }
    }
    let params = Object.fromEntries(new URLSearchParams(location.search));
    if (params.a?.toUpperCase() === config.DEPARTMENTS.VIP.NAME && params.g?.toUpperCase() === GATE_CONSTANTS.VIP) {
      config.CHAT_PROVIDER = ChatProviders.WEBEX
    }

    ENVIRONMENT.PROPERTIES = config;
    ENVIRONMENT.OUTPUT = config?.output;
    ENVIRONMENT.PROPERTIES.CHAT_PROVIDER = ChatProviders.WEBEX;
    ENVIRONMENT.PROPERTIES.apiUrl = endpointHostname;
    ENVIRONMENT.PROPERTIES.EXTERNAL_API = config.EXTERNAL_API;

    platformBrowserDynamic([
      {
        provide: CONFIG,
        useFactory: (config: Config) => config,
        useValue: config,
        multi: true
      },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
